import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { useUsersService } from '../../../../apis/users/useUsersService';
import { TVisitorListApiResponse } from '../../../../apis/users/users.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getVisitorsListKey = 'get-visitors-list';

export const useVisitorsListHook = (
  params: TPaginationParams,
  options?: Omit<UseQueryOptions<TVisitorListApiResponse, TQueryError>, 'queryKey' | 'queryFn'>
): UseQueryResult<TVisitorListApiResponse, TQueryError> => {
  const { getVisitorList } = useUsersService();

  return useQuery<TVisitorListApiResponse, TQueryError>({
    queryKey: [getVisitorsListKey, params],
    queryFn: () => getVisitorList(params),
    enabled: true,
    ...options,
  });
};
